// "Today" / "Yesterday" / "Sep 3" style label plus a full timestamp for
// tooltips, from a unix timestamp in seconds.
export default function formatRelativeDate(timestamp) {
    if (!timestamp) return { short: '-', full: '' };

    const date = new Date(timestamp * 1000);
    const now = new Date();

    const fullFormat = new Intl.DateTimeFormat('en-GB', {
        day: 'numeric', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: false,
    });
    const full = fullFormat.format(date);

    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterdayStart = new Date(todayStart);
    yesterdayStart.setDate(yesterdayStart.getDate() - 1);

    let short;
    if (date >= todayStart) {
        short = 'Today';
    } else if (date >= yesterdayStart) {
        short = 'Yesterday';
    } else if (date.getFullYear() === now.getFullYear()) {
        short = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(date);
    } else {
        short = new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(date);
    }

    return { short, full };
}
